import Page from './Page';

const getQueryValue = (params, key) => {
  const value = params.get(key);
  if (!value) return '';
  // Some links may include '+' for spaces; normalize to a real space.
  return value.replace(/\+/g, ' ');
};

function App() {
  const params = new URLSearchParams(window.location.search);

  const pageProps = {
    agentId: params.get('agentId') || '',
    customerId: params.get('customerId') || '',
    driverName: getQueryValue(params, 'driverName'),
    productName: getQueryValue(params, 'productName'),
    buyId: params.get('id') || '',
  };

  return <Page {...pageProps} />;
}

export default App;
